<template>
  <v-navigation-drawer width="100%" permanent>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="title"> منو کاربری </v-list-item-title>
        <v-list-item-subtitle>توسعه سواد خواندن</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider />
    <v-list dense nav>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        link
        router
        :to="{ name: item.router }"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  name: "navigation-component",
  data: () => {
    return {
      items: [
        {
          title: "پروفایل",
          icon: "mdi-card-account-details-outline",
          router: "Profile"
        },
        {
          title: "لیست آزمون ها",
          icon: "mdi-list-status",
          router: "MyExams"
        },
        {
          title: "لیست تراکنش ها",
          icon: "mdi-book-open-page-variant-outline",
          router: "MyOrders"
        }
      ]
    };
  }
};
</script>
